import React, { useEffect } from 'react'
import { AppDispatch, RootState } from '../../redux-stores/store';
import { useDispatch, useSelector } from 'react-redux';
import { fetchAccountDeletionRequestsThunk } from '../../redux-stores/slices/influencerSlice';
import { requestAccountDeletion } from '../../services/api/influencer';

const AccountDeletion = () => {
    const [loading, setLoading] = React.useState(false);
    const accountDeletionRequestsData = useSelector((state: RootState) => state.influencer.accountDeletionRequests);
    const accountDeletionRequests = accountDeletionRequestsData.items ?? [];
    const fetchingAccountDeletionRequests = accountDeletionRequestsData.loading;

    const dispatch: AppDispatch = useDispatch();

    useEffect(() => {
        dispatch(fetchAccountDeletionRequestsThunk({}));
    }, [dispatch]);

    const requestDeletion = async () => {
        setLoading(true);
        try {
            await requestAccountDeletion();
            dispatch(fetchAccountDeletionRequestsThunk({ force: true }));
        } catch (error) {
            console.error("Failed to request account deletion:", error);
        } finally {
            setLoading(false);
        }
    }

    return (
        <div>
            <div className="d-flex flex-column gap-075">
                <h4 className="new-slide-up-modal-heading fs-18 text-dark fw-600 mt-1 px-18 pt-4">Request Account Deletion</h4>

            </div>
            <div className="section-divider"></div>
            <div className="px-18">
                <span className="fs-14 text-dark fw-400">
                    Request to permanently delete your account and all associated data.
                </span>
                <div className="">
                    <div className="d-flex flex-column gap-2">
                        {
                            accountDeletionRequests.map((request, index) => (
                                <div key={index} className="border rounded-3 p-2">
                                    <div>
                                        <b>Request Date:</b> {request.created}
                                    </div>
                                    <div>
                                        <b>Status:</b> <span className={`fw-bold ${request.status === 'pending' ? 'text-warning' : (request.status === 'rejected' ? 'text-danger' : '')}`}>{request.status.toUpperCase()}</span>
                                    </div>
                                </div>
                            ))
                        }
                    </div>
                    <div className="bg-warning-light text-warning p-075 rounded-3 fs-14 fw-400 mt-2 mb-18">
                        If you have active collaborations, please complete them before requesting account deletion.
                    </div>
                    <h6 className='m-0 fs-16 text-dark fw-600 mb-1'>What Happens After You Request Deletion?</h6>
                    <ul className='fs-14 text-dark fw-400 list-style-none'>
                        <li className='mb-1'>Your account will be reviewed to ensure there are no active collaborations.</li>
                        <li className='mb-1'>Once verified, your account will be permanently deleted within <b className='p-0'>7 days</b>.</li>
                        <li className='mb-1'>All personal information associated with your account will be removed.</li>
                        <li className='mb-1'>You will receive an email confirmation once deletion is complete.</li>
                    </ul>

                </div>

                {/* Save Changes Button */}
                <div className="campaign-apply-ig-connect-benefit-actions pb-5">
                    <button disabled={accountDeletionRequests.length > 0 || loading || fetchingAccountDeletionRequests} onClick={requestDeletion} className="btn btn-primary w-100">{fetchingAccountDeletionRequests ? 'Please wait...' : 'Request Deletion'}</button>
                </div>
            </div>
        </div>
    )
}

export default AccountDeletion
